module.exports = __webpack_public_path__ + "img/9788901101743.f47e6dfb.jpg";